import { getBposNavBarDataAsync } from 'owa-bpos-store';
import { CORS_MODE_NAME, FetchRequestOptions, fetchService } from 'owa-data-provider-info-fetcher';
import { logNoBPOSForDriveId } from 'owa-fluid-datapoints';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';

export async function getSpecialFolderInfo(folderName: string): Promise<string | null> {
    let folderInfo: string = null;

    if (!folderName) {
        throw new Error('No folderName was received.');
    }

    const bposNavBarData = await getBposNavBarDataAsync();
    if (bposNavBarData) {
        try {
            const rootUrl = bposNavBarData.SPO_MySiteHostUrl;
            const requestUrl = rootUrl + '_api/v2.0/me/drive/special/' + folderName;

            const requestOptions: FetchRequestOptions = {
                method: 'GET',
                mode: CORS_MODE_NAME,
                body: null,
                datapointNamePrefix: 'getSpecialFolderInfo',
            };

            const responseText = await fetchService(
                AttachmentDataProviderType.OneDrivePro,
                requestUrl,
                requestUrl,
                requestOptions,
                null // additionalHeaders
            );

            if (responseText) {
                folderInfo = JSON.parse(responseText).name;
            } else {
                throw new Error('getSpecialFolderInfo - no response was received');
            }
        } catch (error) {
            throw error;
        }
    } else {
        logNoBPOSForDriveId();
        throw new Error('getSpecialFolderInfo - FluidNoBPOSForDriveId');
    }

    return folderInfo;
}
